module.exports = __webpack_public_path__ + "static/img/eyebrows_02.80a481a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyebrows/thumbnail/eyebrows_02.png
// module id = WIy5
// module chunks = 0